
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns95fa103e2772247b22acf9c8b987c186en from './en.yaml'
            i18n.addResourceBundle('en', '95fa103e2772247b22acf9c8b987c186', flattenObject(ns95fa103e2772247b22acf9c8b987c186en), true, true);
        
        export default '95fa103e2772247b22acf9c8b987c186';
    